import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { PageHeaderComponent } from '../../atoms/page-header/page-header.component';
import { InfoCardComponent } from '../../molecules/info-card/info-card.component';
import { LoaderWrapperComponent } from '../../atoms/loader-wrapper/loader-wrapper.component';
import { DeviceEventsCard } from '../../molecules/device-events-card/device-events-card.component';
import { TranslocoDatePipe } from '@jsverse/transloco-locale';
import { IconComponent } from '@ui';

@Component({
  selector: 'ui-events-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoDirective,
    PageHeaderComponent,
    InfoCardComponent,
    LoaderWrapperComponent,
    DeviceEventsCard,
    TranslocoDatePipe,
    IconComponent
  ],
  template: `
    <ng-container *transloco="let t">
      <ui-page-header [class]="'bg-teal-200'">
        <div class="col-span-1 sm:col-span-6 xl:col-span-9">
          <ui-info-card
            [title]="t('EVENTS.LABEL')"
            icon="notification"
            [iconClasses]="'text-cyan-400'"
          >
          <p class="text-gray-500">
            {{ t('EVENTS.LAST_DATE') }}
            {{
              lastEventsdate()
                ? (lastEventsdate()| translocoDate: { dateStyle: 'short', timeStyle: 'short' })
                : '--'
            }}
            <ui-icon class="text-black" icon="reload"/>
          </p>
          </ui-info-card>
        </div>
        <div class="col-span-1 sm:col-span-6 xl:col-span-3">
          <ui-loader [loading]="loading()" loadingType="skeletonCard">
            <ui-device-events-card
              [icon]="'eye'"
              [label]="t('EVENTS.UNREAD')"
              [count]="eventsCount()"
            />
          </ui-loader>
        </div>
      </ui-page-header>
    </ng-container>
  `,
})
export class EventsHeaderComponent {
  eventsCount = input<number | null>(null);
  lastEventsdate = input<any>('');
  loading = input<boolean>(true);
}
